type DebouncedFunction<T extends (...args: any[]) => any> = {
  (...args: Parameters<T>): void;
  cancel: () => void;
  flush: () => void;
};

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): DebouncedFunction<T> {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  let pendingArgs: Parameters<T> | null = null;

  const debouncedFn = (...args: Parameters<T>): void => {
    pendingArgs = args;

    if (timeout !== null) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      timeout = null;
      pendingArgs = null;
      func(...args);
    }, wait);
  };

  debouncedFn.cancel = (): void => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
    pendingArgs = null;
  };

  debouncedFn.flush = (): void => {
    if (timeout === null || pendingArgs === null) {
      return;
    }

    clearTimeout(timeout);
    timeout = null;
    const args = pendingArgs;
    pendingArgs = null;
    func(...args);
  };

  return debouncedFn;
}
